import { APP_EVENT_TYPES, AppEventType, isBotStatusReadyActivity } from '@sa/cassius-contract';
import { sendMessageToApp } from '../hostInteractions/hostInteractions';
import { INCOMING_ACTIVITY } from 'botframework-webchat-core/lib/actions/incomingActivity';
import { createAnyAppEvent, createBotStatusAppEvent } from './app-events';

/** App events that are sent to the app and for which the bot expects a response. */
const WAIT_APP_EVENT_TYPES: AppEventType[] = ['channelSwap'];

/** App events that are sent to the app and for which no response is expected. */
const NO_WAIT_APP_EVENT_TYPES: AppEventType[] = APP_EVENT_TYPES.filter(
  (event) => !WAIT_APP_EVENT_TYPES.includes(event)
);

/**
 * Middleware to post a message to the window when an app-destined event arrives.
 */
export const outgoingAppMessageHandlerMiddleware = ({}) => (next) => (action) => {
  if (action.type === INCOMING_ACTIVITY) {
    if (isBotStatusReadyActivity(action.payload.activity)) {
      sendMessageToApp(createBotStatusAppEvent(action.payload.activity));
    } else if (NO_WAIT_APP_EVENT_TYPES.includes(action.payload.activity?.value?.type)) {
      sendMessageToApp(createAnyAppEvent(action.payload.activity.value));
    }
  }
  return next(action);
};
